import type { NavigationMenuItem } from '@nuxt/ui'

import {
  adminSettingsAppearancePath,
  adminSettingsEmailPath,
  adminSettingsPasswordPath,
  adminSettingsProfilePath,
  adminSettingsSessionsPath,
} from '@/routes'

export interface SettingsPage {
  label: string
  description: string
  icon: string
  to: string
}

export const settingsPages = [
  {
    label: 'Profile',
    description: 'Name and account identity',
    icon: 'i-lucide-user',
    to: adminSettingsProfilePath(),
  },
  {
    label: 'Email',
    description: 'Address and verification',
    icon: 'i-lucide-mail',
    to: adminSettingsEmailPath(),
  },
  {
    label: 'Password',
    description: 'Credential security',
    icon: 'i-lucide-lock-keyhole',
    to: adminSettingsPasswordPath(),
  },
  {
    label: 'Sessions',
    description: 'Signed-in devices',
    icon: 'i-lucide-monitor-dot',
    to: adminSettingsSessionsPath(),
  },
  {
    label: 'Appearance',
    description: 'Theme preference',
    icon: 'i-lucide-palette',
    to: adminSettingsAppearancePath(),
  },
] satisfies SettingsPage[]

export function getSettingsNavigationItems(currentUrl: string, onSelect?: () => void): NavigationMenuItem[] {
  return settingsPages.map(item => ({
    label: item.label,
    icon: item.icon,
    to: item.to,
    active: currentUrl.startsWith(item.to),
    onSelect,
  }))
}
